
export enum TessadataDatasetType{
    LOCATION_DATA = 'LOCATION_DATA',
    POINT_OF_INTEREST = 'POINT_OF_INTEREST'
}